interface EllipsifyOptions {
  maxLength?: number
}

/**
 * Adds ellipsis to a string if required. Also provides other useful formatting options
 *
 * @param value The value to ellipsify
 * @param options.limiter If specified, tries to make sure the ellipsis is added keeping this character intact. Useful to maintain semantic sense after ellipsification
 */
const ellipsify = (
  value: string,
  { maxLength = 100 }: EllipsifyOptions = {}
): string => {
  if (value.length <= maxLength) {
    return value
  }

  return `${value.slice(0, maxLength - 1)}…`
}

export default ellipsify
